module.exports = __webpack_public_path__ + "static/Millie-00519a23b45de6e5cf9beca3186afcd0.png";